import * as types from './types';
export default {
  [types.SET_CART_SUCCESS](state, payload) {
    var currentState = state;
    currentState.success = payload;
  },

  [types.SET_CART_SUCCESS_SERVER](state, payload) {
    var currentState = state;
    currentState.successServer = payload;
  },

  [types.SET_CART](state, payload) {
    var currentState = state;
    currentState.items = payload;
  },

  [types.SET_CART_QTY](state, payload) {
    var currentState = state;
    currentState.total = payload;
  },

  [types.SET_CART_STATE](state, payload) {
    var currentState = state;
    currentState.cartState = payload;
  }

};